module.exports = __webpack_public_path__ + "img/files.3b78f7a0.svg";